var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-form"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }